import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  Circle,
  VStack,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";
import Img from "../../../../../components/Img";
import CroppedImageFromFile from "../../../../../components/formComponents/CroppedImage";
import {
  getImageUrls,
  getMinioImage,
  getUpdatedImageUrlWithSize,
} from "../../../../../utils/helpers";
import AbLogo from "../../../../../assets/logo192.png";
import watermark from "../../../../../assets/water.png";
import bg from "../../../../../assets/3dBg.png";
import { CreatedBy } from "../PublicViewRender";
import Disclamer from "../Disclamer";
import classNames from "classnames";
import ImgOptimized from "../../../../../components/ImgOptimized";

const ThreeDPanel = ({
  details,
  companyLogo,
  floorMap,
  isPublicView,
  isPdfView,
  isPdf,
  isShowCreatedBy,
}) => {
  const [areaImageUrl, setAreaImageUrl] = useState("");
  const [base64Images, setBase64Images] = useState({
    companyLogo: "",
    floorMap: "",
    areaImage: "",
  });
  console.log("RENDER GRID", { floorMap, details });

  useEffect(() => {
    // Create URL from File object if it exists
    if (details?.areaImage?.[0] && details.areaImage?.[0] instanceof File) {
      const url = URL.createObjectURL(details.areaImage?.[0]);
      setAreaImageUrl(url);

      // Clean up function to revoke the URL when component unmounts
      return () => URL.revokeObjectURL(url);
    } else if (typeof details?.areaImage?.[0] === "string") {
      // If it's already a URL string, just use it
      setAreaImageUrl(
        getUpdatedImageUrlWithSize(
          getMinioImage(details.areaImage?.[0], true),
          [3, 3, 3],
        ),
      );
    } else {
      setAreaImageUrl("");
    }
  }, [details?.areaImage]);
  const getBase64ImageFromUrl = (url) =>
    new Promise((resolve, reject) => {
      // console.log("RENDER GRID URL" ,url);
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = function () {
        try {
          // Ensure image is fully loaded
          if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");

            // Clear canvas with white background
            ctx.fillStyle = "#FFFFFF";
            // ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw image
            ctx.drawImage(img, 0, 0);

            // Convert to base64 with error handling
            try {
              const dataURL = canvas.toDataURL("image/png");
              if (dataURL && dataURL.startsWith("data:image/")) {
                console.log(
                  `Successfully converted image: ${url.substring(0, 50)}...`,
                );
                resolve(dataURL);
              } else {
                throw new Error("Invalid data URL generated");
              }
            } catch (canvasError) {
              console.error("Canvas conversion failed:", canvasError);
              resolve(url); // Fallback to original URL
            }
          } else {
            console.error("Image not properly loaded:", url);
            resolve(url); // Fallback to original URL
          }
        } catch (error) {
          console.error("Error in image processing:", error);
          resolve(url); // Fallback to original URL
        }
      };

      img.onerror = function (e) {
        console.error("Failed to load image:", url, e);
        resolve(url); // Fallback to original URL
      };

      // Add timeout to prevent hanging
      setTimeout(() => {
        if (!img.complete) {
          console.warn("Image loading timeout:", url);
          resolve(url); // Fallback to original URL
        }
      }, 10000); // 10 second timeout

      img.src = url;
    });
  async function setBase64() {
    try {
      const companyLogobase = await getBase64ImageFromUrl(
        getImageUrls([companyLogo], true, true)?.[0],
      );
      const floorMapBase = await getBase64ImageFromUrl(
        getImageUrls([floorMap], true, true)?.[0],
      );
      const areaImage = await getBase64ImageFromUrl(
        getImageUrls([details?.areaImage?.[0]], true, true)?.[0],
      );
      // console.log("RENDER GRID -----", areaImage );
      setBase64Images((p) => ({
        companyLogo: companyLogobase,
        floorMap: floorMapBase,
        areaImage: areaImage,
      }));
    } catch (error) {
      console.error(error.message);
    }
  }
  useEffect(() => {
    if (isPdfView) {
      setBase64();
      // setBase64Images(p=> ({...p, floorMap: floorMapBase}));
      // console.log("Floor Map:", floorMapBase);
      // setAreaImageUrl(companyLogo);
    }
  }, [companyLogo, floorMap, details]);

  // Check if we have all the data needed for rendering
  const hasKeyPlan =
    details?.keyPlan?.areaData &&
    details?.keyPlan?.position &&
    details?.keyPlan?.radius;
  const hasFloorMap =
    floorMap && (floorMap instanceof File || typeof floorMap === "string");

  console.log("ThreeDPanel rendering with:", {
    hasAreaImage: !!areaImageUrl,
    hasKeyPlan,
    hasFloorMap,
    keyPlanDetails: details?.keyPlan,
    areaImageUrl,
    details: details?.areaImage,
    base64Images,
  });

  return (
    <div
      className={` relative  w-full  ${isPdf ? "h-[100svh] overflow-hidden" : "h-full p-2"} bg-white`}
    >
      {isPublicView && (
        <ImgOptimized
          src={watermark}
          className="absolute top-1/2 opacity-30 -translate-x-1/2 -translate-y-1/2  left-1/2 w-4/5 z-10"
          alt=""
        />
      )}
      <div
        //   style={{
        //   backgroundImage: `url(${bg})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   backgroundRepeat: "no-repeat",
        // }}
        className={
          "relative w-full h-full  " +
          (isPublicView ? " bg-white " : " bg-gray")
        }
      >
        <div
          className={`${
            details?.isPotrait ? "w-[70%]" : "w-full"
          } h-full relative overflow-hidden flex items-center justify-center mx-auto`}
        >
          {details?.areaImage?.[0] && (
            <>
              {isPdfView ? (
                <ImgOptimized
                  //  style={{ objectFit: "cover" }}
                  src={base64Images.areaImage}
                  alt="Area Image"
                  width={details?.isPotrait ? "100%" : "100%"}
                  height={"100%"}
                  ObjectFit="cover"
                  className={`${
                    details?.isPotrait ? "w-[100%]" : "w-full"
                  }  h-full object-cover    `}
                />
              ) : (
                <ImgOptimized
                  src={areaImageUrl}
                  alt="Area Image"
                  width={details?.isPotrait ? "100%" : "100%"}
                  height={"100%"}
                  ObjectFit="cover"
                  className={`${
                    details?.isPotrait ? "w-[100%]" : "w-full"
                  }  h-full object-cover  `}
                />
              )}
            </>
          )}
        </div>
        {/* <div
        style={{
          backgroundImage: `url(${isPublicView ? base64Images.companyLogo: getImageUrls([companyLogo], true)?.[0]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="absolute w-40 h-12  top-2 left-2"
      > */}
        {/* <Img src={getImageUrls( [companyLogo])?.[0]} alt="Company Logo" className="w-full h-full object-cover rounded-md" /> */}
        {/* </div> */}
        <div
          className={`flex gap-1 items-center max-w-fit  absolute text-black  ${isPublicView ? "top-2 left-1" : "top-4 left-4"}`}
        >
          {!isPdfView ? (
            <ImgOptimized
              // width="100%"
              // height="100%"
              src={AbLogo}
              className={classNames(
                "w-6 h-6 sm:w-6 sm:h-6 lg:w-6 lg:h-6    object-cover rounded-lg",
                isPublicView ? "xl:w-[5.2vh] xl:h-[5vh]" : "xl:w-8 xl:h-8",
              )}
            />
          ) : (
            <ImgOptimized
              width="100%"
              height="100%"
              src={AbLogo}
              className="w-11  h-10  object-cover"
            />
          )}
          {companyLogo && (
            <>
              <span>x</span>
              {!isPdfView ? (
                <ImgOptimized
                  // width="100%"
                  // height="100%"
                  src={getImageUrls([companyLogo], true, true)?.[0]}
                  className={classNames(
                    "max-w-fit h-4 sm:h-6 lg:h-4  ",
                    isPublicView ? "  xl:h-[5vh] " : "xl:h-8",
                  )}
                />
              ) : (
                <ImgOptimized
                  // width="100%"
                  // height="100%"
                  src={base64Images.companyLogo}
                  className="max-w-fit h-10  "
                />
              )}
            </>
          )}
        </div>
        <div
          className={`py-1 xl:py-2  px-4 font-[500] italic text-[#EABC9D] playfair   rounded-b-md bg-[#06565E] text-center w-fit absolute top-0 left-1/2 -translate-x-1/2 ${isPdfView ? "text-4xl pb-0 pt-0 " : "text-2xl  sm:text-2xl lg:text-lg xl:text-2xl"}`}
        >
          {isPdfView ? (
            <span className=" mb-0 flex items-center justify-center relative bottom-4">
              {details?.area}
            </span>
          ) : (
            details?.area
          )}
        </div>
        {hasFloorMap && hasKeyPlan && (
          <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-20 lg:h-20 xl:w-28 xl:h-28 2xl:w-36 2xl:h-36 overflow-hidden rounded-full absolute top-4 right-4 flex items-center justify-center border border-white/30">
            <div className="w-full h-full">
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? base64Images.floorMap
                    : getImageUrls([floorMap], true, true)?.[0]
                }
                areaData={details.keyPlan.areaData}
                position={details.keyPlan.position}
                radius={details.keyPlan.radius}
                isPublicView={isPublicView}
              />
            </div>
          </div>
        )}
        {/* {details?.isPotrait && ( */}
        <div
          className={`w-36 h-36 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-44   xl:h-44 overflow-hidden rounded-full absolute ${isPdfView ? " top-20 " : " top-[25%] -translate-y-1/2 "} left-10  lg:left-8 xl:left-10 flex items-center justify-center `}
        >
          {details?.selection1 &&
            Object.keys(details?.selection1).length > 0 && (
              <div className="w-full h-full border border-white/30">
                <CroppedImageFromFile
                  imageFile={
                    isPdfView
                      ? base64Images.areaImage
                      : getImageUrls(details?.areaImage, true, true)?.[0]
                  }
                  areaData={details.selection1?.areaData}
                  position={details.selection1?.position}
                  radius={details.selection1?.radius}
                  isPublicView={isPublicView}
                />
              </div>
            )}
        </div>
        {/* )} */}
        {/* {details?.isPotrait && ( */}
        <div
          className={`w-36 h-36 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-44   xl:h-44 overflow-hidden rounded-full absolute ${isPdfView ? "bottom-20" : " top-[80%] -translate-y-[40%] "} right-5 flex items-center justify-center `}
        >
          {details?.selection2 &&
            Object.keys(details?.selection2).length > 0 && (
              <div className="w-full h-full border border-white/30">
                <CroppedImageFromFile
                  imageFile={
                    isPdfView
                      ? base64Images.areaImage
                      : getImageUrls(details?.areaImage, true, true)?.[0]
                  }
                  areaData={details.selection2?.areaData}
                  position={details.selection2?.position}
                  radius={details.selection2?.radius}
                />
              </div>
            )}
        </div>
        {/* )} */}
        <div
          className={`w-36 h-36 sm:w-36 sm:h-36 lg:w-24 lg:h-24 xl:w-44 xl:h-44 overflow-hidden rounded-full absolute ${isPdfView ? " bottom-20 " : " top-[45%] -translate-y-1/2 "} right-5 flex items-center justify-center `}
        >
          {details?.selection3 &&
            Object.keys(details?.selection3).length > 0 && (
              <div className="w-full h-full border border-white/30">
                <CroppedImageFromFile
                  imageFile={
                    isPdfView
                      ? base64Images.areaImage
                      : getImageUrls(details?.areaImage, true, true)?.[0]
                  }
                  areaData={details.selection3?.areaData}
                  position={details.selection3?.position}
                  radius={details.selection3?.radius}
                  isPublicView={isPublicView}
                />
              </div>
            )}
        </div>
        <div
          className={`w-36 h-36 sm:w-36 sm:h-36 lg:w-24 lg:h-24 xl:w-44 xl:h-44 overflow-hidden rounded-full absolute ${isPdfView ? " top-20 " : " top-[80%] -translate-y-[40%] "} left-10 lg:left-8 xl:left-10 flex items-center justify-center `}
        >
          {details?.selection4 &&
            Object.keys(details?.selection4).length > 0 && (
              <div className="w-full h-full border border-white/30">
                <CroppedImageFromFile
                  imageFile={
                    isPdfView
                      ? base64Images.areaImage
                      : getImageUrls(details?.areaImage, true, true)?.[0]
                  }
                  areaData={details.selection4?.areaData}
                  position={details.selection4?.position}
                  radius={details.selection4?.radius}
                  isPublicView={isPublicView}
                />
              </div>
            )}
        </div>
        <div
          className={`absolute ${
            details?.isPotrait
              ? "bottom-0"
              : !details?.selection1
                ? "top-1/2 -translate-y-1/2"
                : "top-1/2 -translate-y-1/2 "
          }  left-1 space-y-1`}
        >
          {details.colorPalette.map((color, idx) => (
            <>
              {/* <div
                style={{ backgroundColor: color }}
                className={`bg-[${color}]  rounded-full ${isPdfView ? "" : isPublicView ? "w-6 h-6 sm:w-9 sm:h-9 lg:w-6 lg:h-6 xl:w-8 xl:h-8 2xl:w-9 2xl:h-9" : "w-4 h-4 sm:w-8 sm:h-8 lg:w-4 lg:h-4 xl:w-8 xl:h-8"}`}
                ></div> */}
              <div
                key={idx}
                style={{ backgroundColor: color }}
                className={`flex  relative items-end justify-center gap-1 ${
                  isPdfView ? "text-xs right-1" : ""
                }   w-20 h-10 rounded-r-md  right-1 ${
                  isPublicView ? "text-[0.52rem]" : "text-[0.52rem]"
                }  px-2 text-white`}
              >
                {color}
              </div>
            </>
          ))}
        </div>
        {!details?.isPotrait && <Disclamer />}
      </div>
      {/* {isShowCreatedBy && (
        <CreatedBy {...isShowCreatedBy} className={"bottom-0 -left-3"} />
      )} */}
    </div>
  );
};

export default ThreeDPanel;
